import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Tabs } from 'antd';
import { TeamOutlined, SafetyOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { hasPermission } from '../../utils/permissions';
import RolesTab from './RolesTab';
import ActionsTab from './ActionsTab';
import PermissionsTab from './PermissionsTab';
import UsersTab from './UsersTab';
import './RBAC.css';

const RBAC = () => {
  const permissions = useSelector(state => state.auth.permissions || []);
  const [activeTab, setActiveTab] = useState('roles');

  // Check if user has permission to view RBAC
  const canViewRBAC = hasPermission(permissions, 'role/view');

  if (!canViewRBAC) {
    return (
      <div className="page-container">
        <div className="page-content">
          <div className="empty-state">
            <div className="empty-state-icon"><SafetyOutlined /></div>
            <div className="empty-state-text">
              You don't have permission to access RBAC Management.
            </div>
          </div>
        </div>
      </div>
    );
  }

  const tabItems = [
    {
      key: 'roles',
      label: (
        <span>
          <TeamOutlined />
          Roles
        </span>
      ),
      children: <RolesTab />
    },
    {
      key: 'actions',
      label: (
        <span>
          <SettingOutlined />
          Actions
        </span>
      ),
      children: <ActionsTab />
    },
    {
      key: 'permissions',
      label: (
        <span>
          <SafetyOutlined />
          Permissions
        </span>
      ),
      children: <PermissionsTab />
    },
    {
      key: 'users',
      label: (
        <span>
          <UserOutlined />
          User Roles
        </span>
      ),
      children: <UsersTab />
    }
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Page Header */}
        <div className="page-header">
          <div className="page-header-title">
            <div className="page-header-icon"><SafetyOutlined /></div>
            <div className="page-header-text">
              <h1>RBAC Management</h1>
              <p>Manage roles, permissions, and user access control</p>
            </div>
          </div>
        </div>

        {/* RBAC Tabs */}
        <div className="card">
          <div className="rbac-container">
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabItems}
              type="card"
              size="large"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RBAC;
